import { loadLoans } from "../common/api";

const model = {
    name: 'loans',
    state: { 
        currentId: '',
        byId: {}
    },
    reducers: {
        setCurrentId: ( state, payload ) => {
            return {
                ...state,
                currentId: payload.lid
            }
        },
        cdcInsert: ( state, payload ) => {
            // might receive assoc insert first, so can't assume first time seeing anying for this id
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.lid]: {
                        ...state.byId[payload.lid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcInsertBorrowers: ( state, payload ) => {
            const [ lid, oid ] = payload.lid.split( '#' );
            let borrowers = [ payload.cdc ];

            return {
                ...state,
                byId: {
                    ...state.byId,
                    [lid]: { 
                        ...state.byId[lid],
                        borrowers: borrowers
                    }
                }
            }
        },
        cdcModify: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [payload.lid]: {
                        ...state.byId[payload.lid],
                        ...payload.cdc
                    }
                }
            }
        },
        cdcModifyBorrower: ( state, payload ) => {
            const [ lid, oid ] = payload.lid.split( '#' );
            const borr = ( state.byId[lid] && state.byId[lid].borrowers ) ? state.byId[lid].borrowers : [];
            const mod = borr.map( b => {
                if ( b.bid === payload.lid ) {
                    return {
                        ...b,
                        ...payload.cdc
                    }
                }
                return b;
            } );
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [lid]: {
                        ...state.byId[lid],
                        borrowers: mod
                    }
                }
            }
        },
        cdcRemove: ( state, payload ) => {
            const keys = Object.keys( state.byId ).filter( f => f !== payload.lid );
            let newObj = {};
            keys.forEach( k => newObj[k] = state.byId[k] );
            return {
                ...state,
                byId: newObj
            }
        },
        cdcRemoveBorrower: ( state, payload ) => {
            const [ lid, oid ] = payload.lid.split( '#' );
            if ( !state.byId[lid] ) {
                return {
                    ...state
                }
            }
            
            let borrowers = state.byId[lid].borrowers.filter( f => ( f.bid !== payload.lid ) );
            
            return {
                ...state,
                byId: {
                    ...state.byId,
                    [lid]: { 
                        ...state.byId[lid],
                        borrowers: borrowers
                    }
                }
            }
        },
        loadedLoans: ( state, payload ) => {
            return {
                ...state,
                byId: {
                    ...state.byId,
                    ...payload
                }
            }
        }
    },
    effects: ( dispatch ) => ( {
        async loadLoans( { aid, uid } ) {
            const list = await loadLoans( aid, uid );
            let byId = {};
            list.forEach( l => byId[l.lid] = l );
            dispatch.loans.loadedLoans( byId );
        },
        insert( { lid, cdc } ) {
            const borrowers = lid.match( '#' );
            if ( borrowers ) {
                dispatch.loans.cdcInsertBorrowers( { lid, cdc } );
            } else {
                dispatch.loans.cdcInsert( { lid, cdc } );
            }
        },
        modify( { lid, cdc } ) {
            const borrower = lid.match( '#' );
            if ( borrower ) {
                dispatch.loans.cdcModifyBorrower( { lid, cdc } );
            } else {
                dispatch.loans.cdcModify( { lid, cdc } );
            }
        },
        remove( { lid } ) {
            const borrower = lid.match( '#' );
            if ( borrower ) {
                dispatch.loans.cdcRemoveBorrower( { lid } );
            } else {
                dispatch.loans.cdcRemove( { lid } );
            }
        },
        setCurrent( { lid } ) {
            dispatch.loans.setCurrentId( { lid } );
        }
    } )
}

export default model;